import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosFlexInstance} from "../../BackofficeApiManager";

type Variables = {
  accountId: string;
};
type Data = boolean;

const resetAccount = async (variables: Variables): Promise<Data> => {
  await axiosFlexInstance.post<boolean, AxiosResponse<boolean>>(`/dev/reset-account/${variables.accountId}`);
  return true;
};

export const useResetAccount = (
  options?: BaseMutationOptions<Data, Variables>
): BaseUseMutationResult<Data, Variables> => {
  return useBaseMutation(resetAccount, {
    ...options,
    prefixKeysToReset: (data, variables) => [["user"], ["account", variables.accountId]],
  });
};
